import { ajaxSend, ApiErrorStatusCode } from '../../../api/api';
const basePath = '/v1/facebook-messenger';
const applicationPath = `${basePath}/applications`;
const pagePath = `${basePath}/pages`;
export function getMessagingList() {
    return ajaxSend({
        path: applicationPath,
    });
}
export function getMessagingHooks(payload) {
    const { appId } = payload;
    return ajaxSend({
        path: `${applicationPath}/${appId}/initiate`,
    });
}
export function addMessagingApp(payload) {
    const { appId, appSecret } = payload;
    return ajaxSend({
        method: 'POST',
        path: applicationPath,
        data: {
            application_id: appId,
            application_secret: appSecret,
        },
    });
}
export function addMessagingPage(payload) {
    const { id, name, appId, pageToken, queueId } = payload;
    return ajaxSend({
        method: 'POST',
        path: `${applicationPath}/${appId}/pages`,
        data: {
            id: id,
            name: name,
            access_token: pageToken,
            queue_id: queueId,
        },
    });
}
export function deleteMessagingApp(payload) {
    const { appId } = payload;
    return ajaxSend({
        method: 'DELETE',
        path: `${applicationPath}/${appId}`,
    });
}
export function deleteMessagingPage(payload) {
    const { pageId } = payload;
    return ajaxSend({
        method: 'DELETE',
        path: `${pagePath}/${pageId}`,
    });
}
export function deleteMessagingInstagramAccount(payload) {
    const { pageId } = payload;
    return ajaxSend({
        method: 'DELETE',
        path: `${basePath}/instagram/account/${pageId}`,
    });
}
export function updateMessagingPage(payload) {
    const { pageId, name, queueId, window_message_enabled, window_message } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${pagePath}/${pageId}`,
        data: {
            name,
            queue_id: queueId,
            window_message_enabled,
            window_message,
        },
    });
}
export function updateInstagramPage({ pageId, name, queueId, story_comments_enabled, story_mentions_enabled, }) {
    return ajaxSend({
        method: 'PUT',
        path: `${basePath}/instagram/account/${pageId}`,
        data: {
            name,
            queue_id: queueId,
            messaging_settings: {
                story_comments_enabled,
                story_mentions_enabled,
            },
        },
    });
}
export function updateMessagingAccessToken(payload) {
    const { applicationId, accessToken, pageId } = payload;
    return ajaxSend({
        method: 'PUT',
        path: `${pagePath}/${pageId}/accessToken`,
        data: {
            application_id: applicationId,
            access_token: accessToken,
        },
        ignoreErrorCodes: [ApiErrorStatusCode.BadRequest],
    });
}
